export default __webpack_public_path__ + "static/media/32g.f878f65a.svg";